import { PatchBankAccountQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchBankAccount/patchBankAccountQuery.type';
import { fetchApi } from '@/config/axiosSetting';

export const patchBankAccountFunction = (
  params: PatchBankAccountQueryParamsType,
) => {
  return fetchApi.patch(
    `/property/reports/${params.id}/accident_users/damaged/bank_information/?damaged_id=${params.damagedId}`,
    { ...params.formData },
  );
};
